import React from "react";
import moment from "moment";
import { useHistory } from "react-router-dom";

import { Button2 } from "@/ui2/atoms/Button";
import { DashboardCard2 } from "@/ui2/molecules/DashboardCard2";
import { DownloadButton } from "@/ui2/molecules/DownloadButton";
import { getAutomationDataAttr } from "@/utils/automationUtils";

import Button from "../../../UI/Button";

export const MemberProfileFiles = (props) => {
  const { viewAllLink, fileList, getFile } = props;
  const history = useHistory();
  return (
    <DashboardCard2
      title="Associated Files"
      Actions={
        <Button2
          onPress={() => history.push(viewAllLink)}
          className="tw:border-transparent"
          variant="text"
          size="sm"
        >
          View All
        </Button2>
      }
    >
      <div>
        <div className={"row mb-2 tw:font-bold d-lg-flex d-none"}>
          <div className={"col-lg-6"}>File Name</div>
          <div className={"col-lg-5"}>Uploaded Date</div>
          <div className={"col-lg-1"} />
        </div>

        {fileList &&
          fileList
            .sort((fileA, fileB) => fileB.timestamp > parseInt(fileA.timestamp))
            .slice(0, 2)
            .filter((file) => file)
            .map((file) => {
              const fileName = file.file_key.substring(file.file_key.lastIndexOf("/") + 1);
              const timestamp = moment.utc(file.timestamp).local().format("MM/DD/YYYY HH:mm");

              return (
                <React.Fragment key={file.file_key}>
                  <div className={"row mb-2 d-lg-flex d-none"}>
                    <div className={"col-lg-6"}>{fileName}</div>
                    <div className={"col-lg-5"}>{timestamp}</div>

                    <DownloadButton
                      onPress={() => getFile(file.file_key)}
                      {...getAutomationDataAttr("associated-file-download-button-desktop")}
                    />
                  </div>

                  <div className={"mb-2 d-lg-none d-block"}>
                    <div className={"d-flex justify-content-between"}>
                      <div>
                        <div className={"tw:font-bold mb-2"}>{fileName}</div>
                        <div>{timestamp}</div>
                      </div>

                      <DownloadButton
                        onPress={() => getFile(file.file_key)}
                        {...getAutomationDataAttr("associated-file-download-button-mobile")}
                      />
                    </div>
                    <hr />
                  </div>
                </React.Fragment>
              );
            })}
      </div>

      <hr />

      <div className={"d-flex justify-content-end pb-3 pr-4"}>
        <Button
          onClick={props.showPopUp}
          className="Btn Btn--pri Btn-sm ml-4 fs-16 text-center text-white"
        >
          Upload File
        </Button>
      </div>
    </DashboardCard2>
  );
};
